import ko from "@/translations/ko/common.json";
import en from "@/translations/en/common.json";
import jp from "@/translations/jp/common.json";
import retrunKO from "@/translations/ko/returnCode.json";
import retrunEN from "@/translations/en/returnCode.json";
import retrunJP from "@/translations/jp/returnCode.json";

export default {
  KO: { ...ko, ...retrunKO },
  EN: { ...en, ...retrunEN },
  JP: { ...jp, ...retrunJP },
};
